<template>
  <form :class="[formClass]" :style="[formStyle]">
    <slot />
  </form>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'Form',
    props: {
      formClass: {
        type: String,
        required: false,
        default: '',
      },
      formStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
    },
  });
</script>

<style></style>
